import gql from 'graphql-tag';

const UPDATE_SHIPPING_DATA = gql`mutation updateShippingData ($input: UpdateShippingDataInput) {
    updateShippingData (input: $input) {
        status
        message
        data {
            generalError
            notFound
            shippingNotValid
            ok
        }
    }
}`;

export default UPDATE_SHIPPING_DATA;
